const URL_PATTERN = /(https?:\/\/[^\s]+[^\s.,;:!?)])/g;

export function linkifyText(text) {
  if (!text) return text;
  const parts = text.split(URL_PATTERN);
  return parts.map((part, i) =>
    /^https?:\/\//.test(part) ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'var(--gold-dark)', textDecoration: 'underline', wordBreak: 'break-all' }}
      >
        {part}
      </a>
    ) : (
      <span key={i}>{part}</span>
    )
  );
}
